const FormFieldDef = [
    { key: 'label', label: 'Label', type: 'text' },
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'type', label: 'Type', type: 'type' },
    { key: 'case', label: 'Text capitalization', type: 'text', forType: 'text' },
    { key: 'value', label: 'Value', type: 'text' },
    { key: 'options', label: 'Options', type: 'text', forType: 'select' },
    { key: 'allowEmptyOption', label: 'Allow empty option', type: 'checkbox', forType: 'select' },
    { key: 'defaultOption', label: 'Default option', type: 'text', forType: 'select' },
    { key: 'index', label: 'Index', type: 'number' },
    { key: 'description', label: 'Description', type: 'text' },
    { key: 'fields', label: 'Related fields (single)', type: 'text', forType: 'relation' },
    { key: 'fields', label: 'Related fields (multiple)', type: 'text', forType: 'multiplerelation' },
    { key: 'fields', label: 'Related fields (system)', type: 'text', forType: 'systemrelation' },
    { key: 'sourceField', label: 'Source field', type: 'text', forType: 'systemrelation' },
    { key: 'inlineAdjust', label: 'Inline +/- controls', type: 'checkbox', forType: 'number' },
    { key: 'quickDefault', label: 'Quick Default', type: 'checkbox' },
    { key: 'quickSetValue', label: 'Quick Set Value', type: 'text' },
    { key: 'codeLength', label: 'Code length', type: 'number', forType: 'code' },
    { key: 'codePrefix', label: 'Code prefix', type: 'text', forType: 'code' },
    { key: 'codeMode', label: 'Code mode', type: 'codeMode', forType: 'code' },
    { key: 'codeChars', label: 'Code characters', type: 'codeChars', forType: 'code' },
];

export default FormFieldDef;
